import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Factory, CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setMessage("رابط تفعيل غير صالح — الرمز مفقود"); return; }
    api.get("/auth/verify-email", { params: { token } })
      .then((r) => { setStatus("success"); setMessage(`تم تفعيل بريد ${r.data.email} بنجاح`); })
      .catch((e) => { setStatus("error"); setMessage(formatApiError(e)); });
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="verify-email-page">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg p-8 text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-md bg-brand-navy flex items-center justify-center">
            <Factory className="w-5 h-5 text-brand-amber" />
          </div>
          <div className="text-start">
            <div className="font-bold text-brand-navy">MERQAV</div>
            <div className="text-[11px] text-slate-500">MERQAV</div>
          </div>
        </Link>

        {status === "loading" && (
          <div className="py-8">
            <Loader2 className="w-10 h-10 animate-spin text-brand-amber mx-auto mb-3" />
            <div className="text-slate-600">جارٍ التحقق من الرابط...</div>
          </div>
        )}

        {status === "success" && (
          <div className="py-6" data-testid="verify-success">
            <CheckCircle2 className="w-16 h-16 text-emerald-500 mx-auto mb-3" />
            <h1 className="text-2xl font-bold text-brand-navy mb-2">تم التفعيل بنجاح</h1>
            <p className="text-slate-600 mb-6">{message}</p>
            <Link to="/app"><Button className="btn-cta w-full" data-testid="goto-app-btn">الانتقال إلى لوحة التحكم</Button></Link>
          </div>
        )}

        {status === "error" && (
          <div className="py-6" data-testid="verify-error">
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-3" />
            <h1 className="text-2xl font-bold text-brand-navy mb-2">تعذر التفعيل</h1>
            <p className="text-slate-600 mb-6">{message}</p>
            <Link to="/login"><Button variant="outline" className="w-full">العودة لتسجيل الدخول</Button></Link>
          </div>
        )}
      </div>
    </div>
  );
}
